export default __webpack_public_path__ + "9921a865b74f56a320f0b4a81c200322.png";